import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FaturaConfiguracao, FaturaTipo } from './fatura-config.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FaturaConfigService {

  // IMPORTANTE: Ajuste a URL base da sua API 
  private apiUrl = `${environment.webApiSaguiControlUrl}/api/faturaconfiguracao`;

  constructor(private http: HttpClient) { }


  listaConfiguracoes(tpFatura: any): Observable<FaturaConfiguracao[]> {

    return this.http.get<FaturaConfiguracao[]>(
      environment.webApiSaguiControlUrl + '/api/faturaconfiguracao/visualizatodas/' + tpFatura)
  }

  //GET /api/FaturaConfiguracao/{faturaTipo}/{id}
  getConfiguracao(faturaTipo: number, id: number): Observable<FaturaConfiguracao> {
    return this.http.get<FaturaConfiguracao>(`${this.apiUrl}/${id}/${faturaTipo}`);
  }

  // GET /api/FaturaConfiguracao/visualizaporempresa/{empresaId}/{faturaTipo}
  getConfigPorEmpresa(empresaId: number, faturaTipo: number): Observable<FaturaConfiguracao> {
    return this.http.get<FaturaConfiguracao>(`${this.apiUrl}/visualizaporempresa/${empresaId}/${faturaTipo}`);
  }


  // POST /api/FaturaConfiguracao
  addConfiguracao(configuracao: FaturaConfiguracao): Observable<FaturaConfiguracao> {
    return this.http.post<FaturaConfiguracao>(`${this.apiUrl}`, configuracao);
  }

  // PUT /api/FaturaConfiguracao/{id}
  atualizarConfiguracao(id: number, configuracao: FaturaConfiguracao): Observable<FaturaConfiguracao> {
    return this.http.put<FaturaConfiguracao>(`${this.apiUrl}/atualizarconfiguracao/${id}`, configuracao);
  }

  // DELETE /api/FaturaConfiguracao/{id}?faturaTipo={faturaTipo}
  deletarConfiguracao(id: number, faturaTipo: FaturaTipo): Observable<any> {
    const params = new HttpParams().set('faturaTipo', faturaTipo.toString());
    return this.http.delete(`${this.apiUrl}/DeletarConfiguracao/${id}`, { params });
  }
}

